export const GET_NEWS_FEEDS = "src/Analyst/News-Moderation/action/Get_News_Feeds";
export const GET_NEWS_FEEDS_SUCCESS = "src/Analyst/News-Moderation/action/Get_News_Feeds_Success";
export const GET_NEWS_FEEDS_FAILURE = "src/Analyst/News-Moderation/action/Get_News_Feeds_Failure";

export const SEARCH_COUNTERPARTY_NAME = "src/Analyst/News-Moderation/action/Search_Counterparty_Name";
export const SEARCH_COUNTERPARTY_NAME_SUCCESS = "src/Analyst/News-Moderation/action/Search_Counterparty_Name_Success";
export const SEARCH_COUNTERPARTY_NAME_FAILURE = "src/Analyst/News-Moderation/action/Search_Counterparty_Name_Failure";

export const SUBMIT_NEWS_FEED = "src/Analyst/News-Moderation/action/Submit_news_feed";
export const SUBMIT_NEWS_FEED_SUCCESS = "src/Analyst/News-Moderation/action/Submit_news_feed_Success";
export const SUBMIT_NEWS_FEED_FAILURE = "src/Analyst/News-Moderation/action/Submit_news_feed_Failure";

export const getNewsFeeds = (pageCount,newsFeedsPerPage)=>{
    return{
        type:GET_NEWS_FEEDS,
        pageCount,
        newsFeedsPerPage
    }
}

export const getNewsFeedsSuccess = (data)=>{
    return {
        type: GET_NEWS_FEEDS_SUCCESS,
        data
    }
}

export const getNewsFeedsFailure = (data)=>{
    return {
        type : GET_NEWS_FEEDS_FAILURE,
        data
    }
}

export const searchCounterpartyName = (data)=>{
    return{
        type:SEARCH_COUNTERPARTY_NAME,
        data
    }
}

export const searchCounterpartyNameSuccess = (data)=>{
    return {
        type: SEARCH_COUNTERPARTY_NAME_SUCCESS,
        data
    }
}

export const searchCounterpartyNameFailure = (data)=>{
    return {
        type : SEARCH_COUNTERPARTY_NAME_FAILURE,
        data
    }
}

export const submitNewsFeed = (data,pageCount,newsFeedsPerPage)=>{
    return {
        type : SUBMIT_NEWS_FEED,
        data,
        pageCount,
        newsFeedsPerPage
    }
}

export const submitNewsFeedSuccess = (id)=>{
    return {
        type : SUBMIT_NEWS_FEED_SUCCESS,
        id
    }
}

export const submitNewsFeedFailure = (id)=>{
    return {
        type : SUBMIT_NEWS_FEED_FAILURE,
        id
    }
}
